import { render, staticRenderFns } from "./KeyFiguresHome.vue?vue&type=template&id=77fafbf5&scoped=true&"
import script from "./KeyFiguresHome.vue?vue&type=script&lang=js&"
export * from "./KeyFiguresHome.vue?vue&type=script&lang=js&"
import style0 from "./KeyFiguresHome.vue?vue&type=style&index=0&id=77fafbf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fafbf5",
  null
  
)

export default component.exports